import { useEffect, useRef, useState } from 'react'

const VISIBILITY_THRESHOLD = 0.12
const BOTTOM_MARGIN = '0px 0px -8% 0px'

/** Reports once when the element first scrolls into view. */
export function useInView<T extends Element>() {
  const ref = useRef<T>(null)
  const [inView, setInView] = useState(false)

  useEffect(() => {
    const node = ref.current
    if (!node || inView) return

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return
      setInView(true)
      observer.disconnect()
    }, { threshold: VISIBILITY_THRESHOLD, rootMargin: BOTTOM_MARGIN })

    observer.observe(node)
    return () => observer.disconnect()
  }, [inView])

  return { ref, inView }
}
